const CharacterItem = ({ character, style }) => {

  const handleShowCharacter = () => {
    console.log(character, 'handleShowCharacter');
    let data = {
      imageUrl: character?.featured_image_url?.thumbnail || '',
      trailerUrlList: {},
      poseList: character?.models,
    }
    console.log('nativeOpenCamera', data);
      window.nativeOpenCamera(data);
  }

  return (
    <div className="item-character" style={style} onClick={handleShowCharacter}>
      <div className="item-character__img">
        <img src={`${character.featured_image_url.thumbnail}`} alt="" />
      </div>
      <div className="item-character__box-content">
        <p className="character-name text-truncate">{character.name}</p>
        <p className="character-type">{character.models_count || 0}종</p>
        <p className="character-number">캐릭터 수</p>
      </div>
    </div>
  )
}

export default CharacterItem
